<template>
  <Tab as="template" v-slot="{ selected }">
    <button
      :class="[
        'h-10 border-4 border-l-0 form-navigation-item mb-1',
        selected ? 'form-navigation-item-active active-green' : '',
        `border-green`,
      ]"
      :style="
        disabled
          ? 'background:#2b4c11; color:#539a1c; disabled; pointer-events: none;'
          : ''
      "
    >
      <div class="flex flex-row items-center">
        <div v-if="required" class="ml-5 mr-1">
          <template v-if="status === -1 && name !== '事務局より'">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10"
                cy="10"
                r="10"
                :class="selected ? 'fill-white' : `fill-green`"
              />
              <path
                d="M9.99999 2C8.67759 2 7.6591 3.1668 7.83777 4.47707L8.86487 12.0092C8.94228 12.5768 9.4271 13 9.99999 13C10.5729 13 11.0577 12.5768 11.1351 12.0092L12.1622 4.47708C12.3409 3.1668 11.3224 2 9.99999 2Z"
                :class="selected ? `fill-green` : 'fill-white'"
              />
              <path
                d="M9.99999 18C11.1046 18 12 17.1046 12 16C12 14.8954 11.1046 14 9.99999 14C8.89542 14 7.99999 14.8954 7.99999 16C7.99999 17.1046 8.89542 18 9.99999 18Z"
                :class="selected ? `fill-green` : 'fill-white'"
              />
            </svg>
          </template>
          <template v-else-if="status === 0 && name !== '事務局より'">
            <svg
              viewBox="0 0 16 16"
              width="20px"
              height="20px"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="8"
                cy="8"
                r="8"
                :class="selected ? 'fill-white' : `fill-green`"
              />
            </svg>
          </template>
          <template v-else-if="status === 1 && name !== '事務局より'">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10"
                cy="10"
                r="10"
                :fill="selected ? '#fff' : '#549A1D'"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.7374 5.76256C17.4209 6.44598 17.4209 7.55402 16.7374 8.23744L8.73744 16.2374C8.05402 16.9209 6.94598 16.9209 6.26256 16.2374L3.26256 13.2374C2.57915 12.554 2.57915 11.446 3.26256 10.7626C3.94598 10.0791 5.05402 10.0791 5.73744 10.7626L7.5 12.5251L14.2626 5.76256C14.946 5.07915 16.054 5.07915 16.7374 5.76256Z"
                :fill="selected ? '#549A1D' : '#fff'"
              />
            </svg>
          </template>
          <template
            v-else-if="
              name == '事務局より' &&
                !getSentBackItemMessage('office_message')[0]?.isNewest
            "
          >
            <LetterGreen
              class="pt-1 ml-1 mb-1 "
              :class="selected ? 'white-icon' : ''"
              style="display: inline-block;"
              width="18px"
              height="18px"
            ></LetterGreen>
          </template>
          <template
            v-else-if="
              name == '事務局より' &&
                getSentBackItemMessage('office_message')[0]?.isNewest
            "
          >
            <RejectedIcn
              class="mb-1 "
              :class="selected ? 'white-icon' : ''"
              style="display: inline-block;"
              width="20px"
              height="20px"
            ></RejectedIcn>
          </template>

          <!-- <template v-else>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10"
                cy="10"
                r="10"
                :class="selected ? 'fill-white' : 'fill-green'"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14 3.07175C13.0434 2.51947 11.8202 2.84722 11.2679 3.8038L6.76793 11.598L10.232 13.598L14.732 5.8038C15.2843 4.84722 14.9566 3.62403 14 3.07175Z"
                :class="'fill-green'"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.48232 17.0212C6.12762 17.3003 5.61387 17.0037 5.67824 16.557L6.26793 12.4641L9.73203 14.4641L6.48232 17.0212Z"
                :class="'fill-green'"
              />
            </svg>
          </template> -->
        </div>
        <div v-else class="ml-11"></div>
        <span
          v-if="name === '事務局より'"
          :class="['font-bold', selected ? 'text-white' : 'text-green']"
        >
          <span class="text-lg">事務局</span>
          <span class="text-sm">より</span>
        </span>
        <span
          v-else
          :class="['font-bold', selected ? 'text-white' : 'text-green']"
        >
          {{ name }}
        </span>
        <PlusCircleIcn
          v-if="addFilesBtn"
          width="24px"
          class="ml-auto mr-1"
          @click="setFocusToUploader"
        />
        <LetterGreen
          v-if="
            name == '事務局より' &&
              getSentBackItemMessage('office_message')[0]?.isNewest
          "
          class="pt-1 ml-1"
          :class="selected ? 'white-icon' : ''"
          style="display: inline-block;"
          width="18px"
          height="18px"
        ></LetterGreen>
      </div>
    </button>
  </Tab>
</template>
<script>
import { Tab } from '@headlessui/vue'
import PlusCircleIcn from '@/assets/icons/plus-circle.svg?inline'
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import { useReceiptForm } from '@/services/receiptsToda/useReceiptForm'

export default {
  name: 'RequestFormNavigationItem',

  components: {
    Tab,
    PlusCircleIcn,
    LetterGreen,
    RejectedIcn,
  },

  props: {
    name: String,
    required: Boolean, // show status icon
    status: Number, // 0 - default, -1 - error, 1 - success, 2 - edit
    addFilesBtn: Boolean,
    disabled: Boolean,
  },
  setup() {
    const { getSentBackItemMessage } = useReceiptForm()
    return { getSentBackItemMessage }
  },
}
</script>
